import React, { Component, ComponentType } from 'react';
import { connect } from 'react-redux';
import {
  setSelected,
  setSearch,
  setOrder,
  getRecordDetails,
  openFilterCategory,
  closeFilterCategory,
  selectFilterValues,
  setExpanded,
  refreshData,
  refreshSelectedData,
  getDataNextPage,
  syncDataWithCache,
} from '../redux/dynamicTabs/actions';

type MapDispatchToProps = ReturnType<typeof mapDispatchToProps>;

export interface WithDynamicTabTableActionsProviderProps {
  setSelected: (selected: ViewDataSet['selected']) => void;
  setExpanded: (expanded: ViewDataSet['expanded']) => void;
  setSearch: (search: ViewDataSet['search']) => void;
  setOrder: (settings: OrderSettings) => void;
  getRecordDetails: (id: string | number) => void;
  openFilterCategory: (filtersGroups: FilterSettings) => void;
  closeFilterCategory: (filter: string) => void;
  selectFilterValues: (filters: SelectFilterValuesPayload) => void;
  refreshData: () => void;
  refreshSelectedData: (recordsToRefresh: ViewDataSet['selected']) => void;
  getDataNextPage: () => void;
  syncDataWithCache: () => void;
}

type ComponentProps = DynamicTabComponent;
export type ViewDataSetHandler = ComponentProps & MapDispatchToProps;

/**
 * HOC dostarczający akcje reduxowe dla zakładek dynamicznych.
 * Jako argument należy podać komponent widoku zakładki dynamicznej (posiadającej props 'id').
 *
 * @param Cmp
 */
const withDynamicTabTableActionsProvider = <P extends ComponentProps>(Cmp: ComponentType<P>) => {
  class Controller extends Component<ViewDataSetHandler> {
    render(): React.ReactElement {
      const {
        setSelected,
        setSearch,
        setOrder,
        getRecordDetails,
        openFilterCategory,
        closeFilterCategory,
        selectFilterValues,
        setExpanded,
        refreshData,
        refreshSelectedData,
        getDataNextPage,
        syncDataWithCache,
        ...rest
      } = this.props;
      return (
        <Cmp
          {...(rest as P)}
          setSelected={setSelected}
          setExpanded={setExpanded}
          setSearch={setSearch}
          setOrder={setOrder}
          getRecordDetails={getRecordDetails}
          openFilterCategory={openFilterCategory}
          closeFilterCategory={closeFilterCategory}
          selectFilterValues={selectFilterValues}
          refreshData={refreshData}
          refreshSelectedData={refreshSelectedData}
          getDataNextPage={getDataNextPage}
          syncDataWithCache={syncDataWithCache}
        />
      );
    }
  }
  return connect(null, mapDispatchToProps)(Controller);
};

const mapDispatchToProps = (dispatch: any, { id }: ComponentProps) => ({
  setSelected: (selected: ViewDataSet['selected']) => dispatch(setSelected(id, selected)),
  setExpanded: (expanded: ViewDataSet['expanded']) => dispatch(setExpanded(id, expanded)),
  setSearch: (search: ViewDataSet['search']) => dispatch(setSearch(id, search)),
  setOrder: (settings: OrderSettings) => dispatch(setOrder(id, settings)),
  getRecordDetails: (recordId: string | number) => dispatch(getRecordDetails(id, recordId, false)),
  openFilterCategory: (filtersGroups: FilterSettings) => dispatch(openFilterCategory(id, filtersGroups)),
  closeFilterCategory: (filter: string) => dispatch(closeFilterCategory(id, filter)),
  selectFilterValues: (filters: SelectFilterValuesPayload) => dispatch(selectFilterValues(id, filters)),
  refreshData: () => dispatch(refreshData(id)),
  refreshSelectedData: (recordsToRefresh: ViewDataSet['selected']) => dispatch(refreshSelectedData(id, recordsToRefresh)),
  getDataNextPage: () => dispatch(getDataNextPage(id)),
  syncDataWithCache: () => dispatch(syncDataWithCache(id)),
});

export default withDynamicTabTableActionsProvider;
